import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { BoostAdDialogComponent } from '@shared/components/boost-ad-dialog/boost-ad-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewportService } from '@shared/services/viewport.service';
import { User } from '@core/models';

@Component({
	selector: 'app-place-ad-success',
	templateUrl: './place-ad-success.component.html',
	styleUrls: ['./place-ad-success.component.scss'],
})
export class PlaceAdSuccessComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private title: Title,
		public auth: AuthService,
		public locale: LocaleService,
		private dialog: MatDialog,
		public viewport: ViewportService
	) {}

	id: string;
	fromLogin: boolean = false;
	user: User = this.auth.user();
	cat: string = '0';

	onOpenBoostAdDialog(adId, catId) {
		const BOOST_DIALOG = this.dialog.open(BoostAdDialogComponent, {
			maxWidth: '425px',
			width: '96%',
			maxHeight: '700px',
			data: {
				adID: adId,
				catId: catId,
				lang: this.locale.lang,
				package: 'vip',
			},
		});
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['id']) {
				this.id = queries['id'];
			}

			if (queries['login']) {
				this.fromLogin = true;
			}

			if (queries['Cat']) {
				this.cat = queries['Cat'];
			}
		});

		if (this.id && !!this.user) {
			this.auth.intercomUpdate(this.id);
		}

		this.title.setTitle(this.locale.translations['payment']['n346'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
